import React from "react";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import "./Products.css";
import Usernav from "./Usernav";
import Sellernav from "./Sellernav";
import Adminnav from "./Adminnav";
import { useNavigate } from "react-router-dom";
import toastify from "../Util/toastify";
import BaseURL from "../Util/BaseURL";

const Products = () => {
  var nav = useNavigate();
  const location = useLocation();
  const [data, setData] = useState({});
  const [image, setImage] = useState();
  const [price, setPrice] = useState();
  const [cp, setCp] = useState();
  const [discount, setDiscount] = useState();
  const [cd, setCd] = useState();
  const [quantity, setQuantity] = useState(1);
  const [cq, setCq] = useState();
  const [sellerId, setSellerId] = useState();
  const [state, setState] = useState(0);

  async function getProduct() {
    const resImg = await axios.get(
      `${BaseURL}getImages?id=${location.state.productId}`
    );
    setImage(resImg.data[0].url);

    const response = await axios.get(
      `${BaseURL}getProduct?id=${location.state.productId}`
    );
    setData(response.data);
  }
  async function getPrice() {
    let proid = data.productId;
    const r = await axios.get(
      `${BaseURL}GetPriceByID?id=${location.state.productId}`
    );
    setPrice(r.data[0].price);
    setSellerId(r.data[0].sellerid);
    setDiscount(r.data[0].discount);
  }

  const passCart = async () => {
    const statusFlag = true;
    const resGet = await axios.get(
      `${BaseURL}getCartById?id=${
        location.state.productId
      }&name=${sessionStorage.getItem("user")}`,
      { headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") } }
    );
    if (resGet.data.length > 0) {
      toastify("Product Already added to cart", "success");
    } else {
      const res = await axios.post(
        `${BaseURL}addToCart`,
        {
          username: sessionStorage.getItem("user"),
          product_id: location.state.productId,
          quantity: quantity,
          price: price,
          sellerId: sellerId,
        },
        {
          headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") },
        }
      );
      toastify("Product added to cart", "success");
    }
  };
  function toCart() {
    if (
      !(
        sessionStorage.getItem("c") === "User" ||
        sessionStorage.getItem("c") === "Seller" ||
        sessionStorage.getItem("c") === "Admin"
      )
    ) {
      toastify("You need to login first", "error");
      nav("/Login");
    } else {
      passCart();
    }
  }

  function updateStock() {
    axios.post(
      `${BaseURL}updateProductQuantity?product_id=${location.state.productId}&quantity=${cq}&sign=1`,
      {},
      { headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") } }
    );
    toastify("Stock Quantity Updated", "success");
    nav("/SellerPanel/ProductCatlog");
    onClickBack();
  }

  function updatePrice() {
    axios.post(
      `${BaseURL}updateProductPrice?product_id=${location.state.productId}&price=${cp}`,
      {},
      { headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") } }
    );
    toastify("Stock Price Updated", "success");
    nav("/SellerPanel/ProductCatlog");
    onClickBack();
  }

  function updateDiscount() {
    axios.post(
      `${BaseURL}updateProductDiscount?product_id=${location.state.productId}&discount=${cd}`,
      {},
      { headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") } }
    );
    toastify("Stock Price Updated", "success");
    nav("/SellerPanel/ProductCatlog");
    onClickBack();
  }

  function onclickBtn() {
    if (state === 1) {
      document.getElementById("mainBtns").style.display = "none";
      document.getElementById("updateStock").style.display = "block";
    } else if (state === 2) {
      document.getElementById("mainBtns").style.display = "none";
      document.getElementById("updatePrice").style.display = "block";
    } else {
      document.getElementById("mainBtns").style.display = "none";
      document.getElementById("updateDiscount").style.display = "block";
    }
  }
  function onClickBack() {
    if (state === 1) {
      document.getElementById("mainBtns").style.display = "block";
      document.getElementById("updateStock").style.display = "none";
    } else if (state === 2) {
      document.getElementById("mainBtns").style.display = "block";
      document.getElementById("updatePrice").style.display = "none";
    } else {
      document.getElementById("mainBtns").style.display = "block";
      document.getElementById("updateDiscount").style.display = "none";
    }
  }
  useEffect(() => {
    getProduct();
  }, []);
  useEffect(() => {
    getPrice();
  }, []);

  return (
    <>
      {sessionStorage.getItem("c") === "User" ? (
        <Usernav />
      ) : sessionStorage.getItem("c") === "Seller" ? (
        <Sellernav />
      ) : sessionStorage.getItem("c") === "Admin" ? (
        <Adminnav />
      ) : (
        <Usernav />
      )}
      <div className="singleProduct d-none d-xl-block d-lg-block d-md-block">
        <div className="row gx-0 pro">
          <div className="cardPro">
            <img className="productImage" src={image} alt="..." />
          </div>
          <div className="col-md-5 des">
            <h4 className="text-uppercase text-black-50">{data.category}</h4>
            <h1 className="display-5">{data.title}</h1>
            <h3 className="display-6 fw-bold my-4">Price : {price}</h3>
            <p className="lead">{data.description}</p>
            {sessionStorage.getItem("c") === "User" ? (
              <>
                <button
                  className="btn btn-outline-dark px-4 py-2"
                  onClick={() => toCart()}
                >
                  {" "}
                  Add to Cart
                </button>
              </>
            ) : sessionStorage.getItem("c") === "Seller" ? (
              <>
                <div className="row" id="mainBtns">
                  <button
                    className=" my-2 btn btn-outline-dark px-4 py-2"
                    onClickCapture={() => setState(1)}
                    onClick={() => onclickBtn()}
                  >
                    {" "}
                    Update Stock
                  </button>
                  <button
                    className=" my-2 btn btn-outline-dark px-4 py-2"
                    onClickCapture={() => setState(2)}
                    onClick={() => onclickBtn()}
                  >
                    {" "}
                    Upadate Price
                  </button>
                  <button
                    className=" my-2 btn btn-outline-dark px-4 py-2"
                    onClickCapture={() => setState(3)}
                    onClick={() => onclickBtn()}
                  >
                    {" "}
                    Update Discount
                  </button>
                </div>
                <div className="updateStock" id="updateStock">
                  <div className="input-line">
                    <label htmlFor="Available Stock">Available Stock</label>
                    <input
                      type="text"
                      name="availableStock"
                      id="availableStock"
                      value={data.quantity}
                      disabled="true"
                    />
                  </div>
                  <div className="input-line">
                    <label htmlFor="Updated Value">Updated Stock</label>
                    <input
                      type="text"
                      name="updatedvalue"
                      id="updatedvalue"
                      placeholder="Enter the updated stock of the product"
                      value={cq}
                      onChange={(e) => setCq(e.target.value)}
                    />
                  </div>
                  <div className="hstack">
                    <div className="updatebtnBACK">
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={() => {
                          onClickBack();
                        }}
                      >
                        Back
                      </button>
                    </div>
                    <div className="updatekbtnUPDATE">
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={() => updateStock()}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
                <div className="updatePrice" id="updatePrice">
                  <div className="input-line">
                    <label htmlFor="Previous Price">Previous Price</label>
                    <input
                      type="text"
                      name="previousPrice"
                      id="previousPrice"
                      value={price}
                      disabled="true"
                    />
                  </div>
                  <div className="input-line">
                    <label htmlFor="Updated Price">Updated Price</label>
                    <input
                      type="text"
                      name="updatedprice"
                      id="updatedprice"
                      placeholder="Enter the updated price of the product"
                      value={cp}
                      onChange={(e) => setCp(e.target.value)}
                    />
                  </div>
                  <div className="hstack">
                    <div className="updatebtnBACK">
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={() => {
                          onClickBack();
                        }}
                      >
                        Back
                      </button>
                    </div>
                    <div className="updatebtnUPDATE">
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={() => updatePrice()}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
                <div className="updateDiscount" id="updateDiscount">
                  <div className="input-line">
                    <label htmlFor="Previous Discount">Previous Discount</label>
                    <input
                      type="text"
                      name="previousDiscount"
                      id="previousDiscount"
                      value={discount}
                      disabled="true"
                    />
                  </div>
                  <div className="input-line">
                    <label htmlFor="Updated Discount">Updated Discount</label>
                    <input
                      type="text"
                      name="updatedDiscount"
                      id="updatedDiscount"
                      placeholder="Enter the updated discount of the product"
                      value={cd}
                      onChange={(e) => setCd(e.target.value)}
                    />
                  </div>
                  <div className="hstack">
                    <div className="updatebtnBACK">
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={() => {
                          onClickBack();
                        }}
                      >
                        Back
                      </button>
                    </div>
                    <div className="updatebtnUPDATE">
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={() => updateDiscount()}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </>
            ) : sessionStorage.getItem("c") === "Seller" ? (
              <></>
            ) : sessionStorage.getItem("c") === "Admin" ? (
              <></>
            ) : (
              <>
                <button
                  className="btn btn-outline-dark px-4 py-2"
                  onClick={() => toCart()}
                >
                  {" "}
                  Add to Cart
                </button>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="singleProduct d-block d-xl-none d-lg-none d-md-none">
        <div className="w-75 mx-auto">
          <img className="w-75 ml-4" src={image} alt="..." />

          <div className="mt-5">
            <h4 className="text-uppercase text-black-50">{data.category}</h4>
            <h1 className="display-5">{data.title}</h1>
            <h3 className="display-6 fw-bold my-4">Price : {price}</h3>
            <p className="lead">{data.description}</p>
            {sessionStorage.getItem("c") === "User" ? (
              <>
                <button
                  className="btn btn-outline-dark px-4 py-2"
                  onClick={() => toCart()}
                >
                  {" "}
                  Add to Cart
                </button>
              </>
            ) : sessionStorage.getItem("c") === "Seller" ? (
              <>
                <div className="row" id="mainBtns">
                  <button
                    className=" my-2 btn btn-outline-dark px-4 py-2"
                    onClickCapture={() => setState(1)}
                    onClick={() => onclickBtn()}
                  >
                    {" "}
                    Update Stock
                  </button>
                  <button
                    className=" my-2 btn btn-outline-dark px-4 py-2"
                    onClickCapture={() => setState(2)}
                    onClick={() => onclickBtn()}
                  >
                    {" "}
                    Upadate Price
                  </button>
                  <button
                    className=" my-2 btn btn-outline-dark px-4 py-2"
                    onClickCapture={() => setState(3)}
                    onClick={() => onclickBtn()}
                  >
                    {" "}
                    Update Discount
                  </button>
                </div>
                <div className="updateStock" id="updateStock">
                  <div className="input-line">
                    <label htmlFor="Available Stock">Available Stock</label>
                    <input
                      type="text"
                      name="availableStock"
                      id="availableStock"
                      value={data.quantity}
                      disabled="true"
                    />
                  </div>
                  <div className="input-line">
                    <label htmlFor="Updated Value">Updated Stock</label>
                    <input
                      type="text"
                      name="updatedvalue"
                      id="updatedvalue"
                      placeholder="Enter the updated stock of the product"
                      value={cq}
                      onChange={(e) => setCq(e.target.value)}
                    />
                  </div>
                  <div className="hstack">
                    <div className="updatebtnBACK">
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={() => {
                          onClickBack();
                        }}
                      >
                        Back
                      </button>
                    </div>
                    <div className="updatekbtnUPDATE">
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={() => updateStock()}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
                <div className="updatePrice" id="updatePrice">
                  <div className="input-line">
                    <label htmlFor="Previous Price">Previous Price</label>
                    <input
                      type="text"
                      name="previousPrice"
                      id="previousPrice"
                      value={price}
                      disabled="true"
                    />
                  </div>
                  <div className="input-line">
                    <label htmlFor="Updated Price">Updated Price</label>
                    <input
                      type="text"
                      name="updatedprice"
                      id="updatedprice"
                      placeholder="Enter the updated price of the product"
                      value={cp}
                      onChange={(e) => setCp(e.target.value)}
                    />
                  </div>
                  <div className="hstack">
                    <div className="updatebtnBACK">
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={() => {
                          onClickBack();
                        }}
                      >
                        Back
                      </button>
                    </div>
                    <div className="updatebtnUPDATE">
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={() => updatePrice()}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
                <div className="updateDiscount" id="updateDiscount">
                  <div className="input-line">
                    <label htmlFor="Previous Discount">Previous Discount</label>
                    <input
                      type="text"
                      name="previousDiscount"
                      id="previousDiscount"
                      value={discount}
                      disabled="true"
                    />
                  </div>
                  <div className="input-line">
                    <label htmlFor="Updated Discount">Updated Discount</label>
                    <input
                      type="text"
                      name="updatedDiscount"
                      id="updatedDiscount"
                      placeholder="Enter the updated discount of the product"
                      value={cd}
                      onChange={(e) => setCd(e.target.value)}
                    />
                  </div>
                  <div className="hstack">
                    <div className="updatebtnBACK">
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={() => {
                          onClickBack();
                        }}
                      >
                        Back
                      </button>
                    </div>
                    <div className="updatebtnUPDATE">
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={() => updateDiscount()}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </>
            ) : sessionStorage.getItem("c") === "Seller" ? (
              <></>
            ) : sessionStorage.getItem("c") === "Admin" ? (
              <></>
            ) : (
              <>
                <button
                  className="btn btn-outline-dark px-4 py-2"
                  onClick={() => toCart()}
                >
                  {" "}
                  Add to Cart
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Products;
